import React, { useState, useContext } from 'react'

import { ITabContext, TabContext } from './TabProvider'

const useTabs = () => {
    const ctx: ITabContext = useContext<ITabContext>(TabContext)
    return ctx
}

export default useTabs
